import gql from 'graphql-tag';

export class AttachmentQueries {
  static documentAttachments = gql`
    query DocumentAttachments($documentId: String!) {
      document(documentId: $documentId) {
        id
        documentAttachments {
          id
          restrictAccess
          requireView
          createdAt
          previewUrl
          attachment {
            attachmentType
            attachmentTitle
            attachmentDescription
            attachmentUrl
            attachmentFilename
            attachmentSize
            attachmentSha
            thumbUrl
            published
            library
            hashId
          }
          accessRecipientList {
            id
            firstName
            lastName
            fullName
            roleName
          }
        }
      }
    }
  `;
}
